import {  Component, OnInit, ViewChild,ChangeDetectorRef,Input } from '@angular/core';
import { DatePipe, NgIf, NgClass, NgFor, DecimalPipe, TitleCasePipe, CurrencyPipe } from '@angular/common';
import { LanguageService, TranslationService, I18nModule } from '@spartacus/core';
import { UntypedFormArray, UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, FormsModule } from '@angular/forms';
import moment from 'moment';
import { DateRangePickerComponent } from 'ngx-daterange/components/datepicker/date-range-picker.component';
import { IDateRange, IDateRangePickerOptions } from 'ngx-daterange/interfaces';
import { NgSelectComponent, NgMultiLabelTemplateDirective, NgOptgroupTemplateDirective, NgOptionTemplateDirective } from '@ng-select/ng-select';
import { ActivatedRoute, Router } from '@angular/router';
import { CustomProductsService } from '../custom-products/custom-products.service';
import { ToastrService } from 'ngx-toastr';
import { QuotesList } from '../../../core/model/quotes-list-model';
import { QuoteEditModel } from '../../../core/model/quote-edit-model';
import { QuoteActionModel } from '../../../core/model/quote-action-model';
import { QuoteStatusModel } from '../../../core/model/quote-status-model';
import { TenderAcceptBidComponent } from 'src/app/shared/components/tender-accept-bid/tender-accept-bid.component';
import { pairwise } from 'rxjs/operators';
import { ElementRef } from '@angular/core';
import { tap } from 'rxjs/operators';
import { QuoteTabNameModel } from '../../../core/model/quote-tab-name-model';
import { ModalConfig } from '../../../core/model/modal.config-model';
import { NgbActiveModal, NgbModal, NgbInputDatepicker } from '@ng-bootstrap/ng-bootstrap';
import {EditBidModalComponent} from 'src/app/shared/components/edit-bid-modal/edit-bid-modal.component';
import { AcceptBidModalComponent } from '../../../shared/components/accept-bid-modal/accept-bid-modal.component';
import { CancelBidModalComponent } from '../../../shared/components/cancel-bid-modal/cancel-bid-modal.component';
import { CouterOfferModalComponent } from '../../../shared/components/counter-offer-modal/counter-offer-modal';
import { RejectBidModalComponent } from '../../../shared/components/reject-bid-modal/reject-bid-modal.component';
import { UserAccountFacade } from '@spartacus/user/account/root';
import { NgbCalendar, NgbDate, NgbDateAdapter, NgbDateParserFormatter, NgbDatepickerI18n } from '@ng-bootstrap/ng-bootstrap';
import { CustomAdapter, CustomDateParserFormatter, DateRangePickerI18nService } from 'src/app/shared/services/date-range-picker-i18n.service';
import { TenderCancelBidComponent } from 'src/app/shared/components/tender-cancel-bid/tender-cancel-bid.component';
import{QuoteSelectProductsComponent} from 'src/app/shared/components/quote-select-products/quote-select-products.component'
// moment.locale('fr');
import { element } from 'protractor';
import { ITBEditBidComponent } from 'src/app/shared/components/itb-edit-bid/itb-edit-bid.component';
import { ITBQuoteSelectProductsComponent } from 'src/app/shared/components/itb-quote-select-products/itb-quote-select-products.component';
import { environment } from 'src/environments/environment';
import { TenderPlaceBidComponent } from 'src/app/shared/components/tender-place-bid/tender-place-bid.component';
import { CustomLoginService } from '../../custom-login/custom-login-form/custom-login.service';
import { CsAgentAuthService } from '@spartacus/asm/root';
import { ConsignmentsPopupmodalComponent } from '../consignments/consignments-popupmodal/consignments-popupmodal.component';
import { CustomProfileService } from 'src/app/core/services/custom-profile.service';
import { CommonPageBreadcrumbsComponent } from '../../../shared/components/common-page-breadcrumbs/common-page-breadcrumbs.component';
import { QuoteStatusStylePipe } from '../../../shared/pipes/quote-status-style-pipe';
@Component({
    selector: 'app-custom-myqoutes',
    templateUrl: './custom-myqoutes.component.html',
    styleUrls: ['./custom-myqoutes.component.scss'],
    providers: [{ provide: NgbDatepickerI18n, useClass: DateRangePickerI18nService }, { provide: NgbDateAdapter, useClass: CustomAdapter },
        { provide: NgbDateParserFormatter, useClass: CustomDateParserFormatter }],
    imports: [CommonPageBreadcrumbsComponent, NgIf, NgSelectComponent, FormsModule, NgMultiLabelTemplateDirective, NgOptgroupTemplateDirective, NgOptionTemplateDirective, NgbInputDatepicker, NgClass, NgFor, AcceptBidModalComponent, CouterOfferModalComponent, RejectBidModalComponent, DecimalPipe, TitleCasePipe, CurrencyPipe, DatePipe, I18nModule, QuoteStatusStylePipe]
})
export class CustomMyqoutesComponent implements OnInit {
  @ViewChild('acceptModal') private acceptModalComponent: AcceptBidModalComponent;
  // @ViewChild('cancelModal') private cancelBidModalComponent: CancelBidModalComponent;
  @ViewChild('counterOfferModal') private couterOfferModalComponent: CouterOfferModalComponent;
  @ViewChild('rejectModal') private rejectBidModalComponent: RejectBidModalComponent;
  public modalConfig: ModalConfig;
  @ViewChild(NgSelectComponent) ngSelectComponent: NgSelectComponent;
  noData = false;
  activeTab = 'active';
  quotesTab = 'active';
  selectedQuateStatus: any = null;
  quoteActionModel = new QuoteActionModel();
  quoteStatusModel = new QuoteStatusModel();
  quoteTabNameModel = new QuoteTabNameModel();
  myGroup: UntypedFormGroup;
  activate: any;
  quoteEditModel = new QuoteEditModel();
  enableLoader = true;
  @ViewChild('quotesPage') closeModalRef: ElementRef<HTMLElement>;
  @ViewChild('dateRangePicker', { static: true })
  dateRangePicker: DateRangePickerComponent;
  @ViewChild('dateRangePicker2', { static: true })
  dateRangePicker2: DateRangePickerComponent;
  @ViewChild('dateRangePickerSingle', { static: true })
  dateRangePickerSingle: DateRangePickerComponent;
  toDate: string = null;
  fromDate: string = null;
  hoveredDate: NgbDate | null = null;
  startDate: NgbDate | null  = null;
  endDate: NgbDate | null = null;
  timeSelected: any = '00:00';
  startDateSingle: any = null;
  endDateSingle: any = null;
  datePipe = new DatePipe('en-US');
  quotesDataMain: any;
  QuoteId: any;
  selectedquote: any;
  tcPrice:any;
  rcPrice:any;
  relativePrice:any;
  quantityRangeArrya = [];
  biddingTerms = '';
  quantitySelected: any = null;
  firstFieldEmittedValueSingleCal: IDateRange;
  locale = {
    // daysOfWeek: moment.localeData('fr').weekdaysMin(),
    // monthNames: moment.lang('zh-CN'),
    // weekdaysShort: moment.lang('zh-CN'),
    // weekdays: moment.lang('zh-CN'),
    // firstDay: moment.localeData('fr').firstDayOfWeek()
   };
  singleCalendarOptions: IDateRangePickerOptions = {
    clickOutsideAllowed: false,
    format: 'DD/MM/YYYY',
    icons: 'font-awesome',
    position: 'right',
    singleCalendar: true,
    minDate: moment().subtract(10, 'years'),
    maxDate: moment().add(1, 'year'),
  };
  firstFieldEmittedValue: IDateRange;
  secondFieldOptions: IDateRangePickerOptions = {
    clickOutsideAllowed: false,
    format: 'DD/MM/YYYY',
    icons: 'font-awesome',
    position: 'right',
    minDate: moment().subtract(10, 'years'),
    maxDate: moment().add(1, 'year'),
  };
  timeArray = [];
  closeModal: any;
  form: UntypedFormGroup = null;
  formDateRange: UntypedFormGroup = null;
  searchInput: any;
  title: any;
  navigationData: string;
  enable = true;
  dataQuotes: any;
  modalReference: any;
  selectedprice: any;
  selectedquantity: any;
  selectedid: any;
  acceptCount: any = 0;
  showCancelledMsg: boolean;
  showAcceptedMsg: boolean;
  showPlacedBidmsg: boolean;
  closeResult: string;
  usergroup: string;
  userid: string;
  errorMessage: any;
  selectedCommodity:any;
  selectedLocation:any;
  samequoteData: QuotesList[] = [];
  quotesData:Array<any>;
  routeReuseStrategy: any;
  isRouteStrategyChanges = false;
  showRejectedMsg = false;
  error: string;
  value: string;
  focus: boolean;
  nextMonth: string;
  preMonth: string;
  selectMonth: string;
  selectYear: string;
  date: any;
  hour: any;
  min: any;
  expiring: string;
  lang:any;
  editInfo:any;
  tenderQuotesListData:Array<any>;
  tenders:any;
  tenderQuote:any;
  COI: boolean =false;
  ITB: boolean= false;
  selectedProduct: any;
  showClear = false;
  searchText = null;
  length: number;
  productlength = 0;
  locationlength=0;
  OpenNegotiation:boolean=true;
  sidebar: boolean;
  materialList: any = [];
  commodityData:any;
  shiplocations:any;
  checkCommodityArray:any;
  checkArray: any;
  checkedcommodityform: UntypedFormGroup;
  checkedproductform: UntypedFormGroup;
  checkedlocationform:UntypedFormGroup
  commoditylength =0;
  writeAccess: boolean;
  isCustomerEmulated: boolean;
  isPlaceBidDisabled: boolean = false;
  isAcceptOfferDisabled: boolean = false;
  second: any;
  orders: any[]=[];
  noBids: boolean = false;
  address:any;
  constructor(private translation: TranslationService,private customProfileService:CustomProfileService,
              private router: Router, private customProductService: CustomProductsService,
              private route: ActivatedRoute, private toastService: ToastrService, private userAccountFacade: UserAccountFacade,
              private calendar: NgbCalendar,
              public ModalService:NgbModal,
              public formatter: NgbDateParserFormatter, private cd: ChangeDetectorRef,
              private fb: UntypedFormBuilder,
              private customloginservice:CustomLoginService,
              private csAgentAuthService:CsAgentAuthService,
              private languageservice:LanguageService
              ) {
            //    this.customProductService.getHomeLinkActive(false);
            this.checkedcommodityform = this.fb.group({
              checkCommodityArray:this.fb.array([])
            });
            this.checkedproductform = this.fb.group({
              checkArray: this.fb.array([])
            });
            this.checkedlocationform = this.fb.group({
              checkLocationArray: this.fb.array([])
            });
              }
  ngOnInit(): void {
    this.customloginservice.getASMAcess().subscribe(res=>{
      this.writeAccess = res?.writeAccess;
      this.csAgentAuthService.isCustomerEmulated().subscribe(emulated => {
        this.isCustomerEmulated = emulated;
        if(this.writeAccess==false&& this.isCustomerEmulated == true){
          this.isPlaceBidDisabled = true;
          this.isAcceptOfferDisabled = true;
        }else{
          this.isPlaceBidDisabled = false;
          this.isAcceptOfferDisabled = false;
        }
      })
    })
        this.customProfileService.getbidsOrdersData().subscribe((name) => {
          if(!name){
            return;
          }
          if (name === 'Orders') {
            this.title = 'Orders';
          } else {
            this.translation.translate('breadcrumb.myQuotes.pageTitle').subscribe(res => {
              this.title = res;
            });
          }
    })

    this.sidebar = true;
    this.customProductService.getHomeLinkActive(false);
    this.customProductService.scrollToTop();
    this.userAccountFacade.get().subscribe((data: any) => {
      if (data) {
        this.userid = data.uid;
        if (this.customProductService.isRedirectFromQuotesDetails) {
          this.isRouteStrategyChanges = true;
          if (this.customProductService.quoteStatusName === this.quoteStatusModel.accepted) {
            this.getQuotesData(this.quoteTabNameModel.accepted);
          } else if (this.customProductService.quoteStatusName === this.quoteStatusModel.bidPlaced) {
            this.getQuotesData(this.quoteTabNameModel.active);
          } else if (this.customProductService.quoteStatusName === this.quoteStatusModel.bidExpired
            || this.customProductService.quoteStatusName === this.quoteStatusModel.offerExpired ||
            this.customProductService.quoteStatusName === this.quoteStatusModel.rejected
            || this.customProductService.quoteStatusName === this.quoteStatusModel.cancelled) {
            this.getQuotesData(this.quoteTabNameModel.archived);
          }
        } else {
          this.getQuotesData(this.quoteTabNameModel.active);
        }
        this.showAcceptedMsg = false;
        this.showCancelledMsg = false;
        this.showPlacedBidmsg = false;
        this.showRejectedMsg = false;
        this.form = new UntypedFormGroup({
          singleCalendar: new UntypedFormControl()
        });
        this.formDateRange = new UntypedFormGroup({
          secondDateRange: new UntypedFormControl()
        });
        this.translation.translate('breadcrumb.myQuotes.breadcrumb').subscribe(res => {
          this.navigationData = res;
        });
        this.translation.translate('home.toastErrorMessages.something').subscribe(res => {
          this.error = res;
        });
        this.translation.translate('home.datePicker.nextMonth').subscribe(res => {
          this.nextMonth = res;
        })
        this.translation.translate('home.datePicker.preMonth').subscribe(res => {
          this.preMonth = res;
        })
        this.translation.translate('home.datePicker.selectMonth').subscribe(res => {
          this.selectMonth = res;
        })
        this.translation.translate('home.datePicker.selectyear').subscribe(res => {
          this.selectYear = res;
        })
        this.languageservice.getActive().subscribe(res => {
          this.lang = res;
        })
        this.translation.translate('home.quote.Expiringin').subscribe(res => {
          this.expiring = res;

        });
        this.translation.translate('home.quote.d').subscribe(res => {
          this.date = res;

        });
        this.translation.translate('home.quote.h').subscribe(res => {
          this.hour = res;

        });
        this.translation.translate('home.quote.m').subscribe(res => {
          this.min = res;

        });
        this.translation.translate('home.quote.s').subscribe(res => {
          this.second = res;

        });

        this.customProductService.languageChange$.pipe(pairwise()).subscribe(([previous, current]) => {
          this.enableLoader = true;
          if (current != null) {
            if (previous !== current) {
              this.enableLoader = true;
              this.selectedProduct = null;
              if (this.router.url === '/quotes/myquotes') {
                this.showAcceptedMsg = false;
                this.showCancelledMsg = false;
                this.showPlacedBidmsg = false;
                this.showRejectedMsg = false;
                this.activeTab = 'active';
                this.quotesTab ='active';
                setTimeout(() => {
                  this.getQuotesData(this.activeTab);        
                }, 1000);
              }
            }
          }
        });
      }
    });

  }

  omit_special_char(event): any {
    const k = event.charCode;
    return ((k > 64 && k < 91) || (k > 96 && k < 123) || k == 8 || k == 32 || (k >= 48 && k <= 57));;
  }

  search(): void {
    this.searchText.toLowerCase();
    if (this.searchText?.length>=3) {
      this.getQuotesDataTabChange(this.activeTab,this.startDate,this.endDate,this.searchText,this.selectedProduct);
    } else if(this.searchText.length == 0) {
      this.getQuotesDataTabChange(this.activeTab,this.startDate,this.endDate,this.searchText,this.selectedProduct);
    }
    this.customProductService.getsearchValue(this.searchText);
  }

  filtersidebar() {
    this.sidebar = false;
  }
  closebar() {
    this.sidebar = true;
  }

  clearFilterMobile(event): void {
    this.closebar();
    const checked = false;
    this.showClear = false;
    // this.productsList.forEach(item => (item.selected = checked));
    this.date = 0;
    this.productlength = 0;
    this.locationlength=0
    this.shiplocations.forEach(item => (item.selected = checked));
    this.commodityData.forEach(item => (item.selected = checked));
    this.materialList.forEach(item => (item.selected = checked));
    this.startDate = null;
    this.endDate = null;
    this.selectedProduct = [];
    this.selectedCommodity=[];
    this.selectedLocation=[];    
    // Clear form arrays
    const checkArray = this.checkedproductform.get('checkArray') as UntypedFormArray;
    const checkLocationArray = this.checkedlocationform.get('checkLocationArray') as UntypedFormArray;
    const checkCommodityArray = this.checkedcommodityform.get('checkCommodityArray') as UntypedFormArray;
    
    //Clear all form array controls
    while (checkArray.length !== 0) {
      checkArray.removeAt(0);
    }
    while (checkLocationArray.length !== 0) {
      checkLocationArray.removeAt(0);
    }
    while (checkCommodityArray.length !== 0) {
      checkCommodityArray.removeAt(0);
    }
    // Make API call with cleared filters
    this.getQuotesDataTabChange(this.activeTab)
  }
  
onDateSelection(date: any, datepicker) {
  this.showClear = true;
  if (!this.startDate && !this.endDate) {
    this.startDate = date;
    
  } else if (
    this.startDate &&
    !this.endDate &&
    date &&
    date.after(this.startDate)
  ) {
    this.endDate = date;
    this.getQuotesDataTabChange(this.activeTab,this.startDate,this.endDate,this.searchText
      ,this.selectedProduct);
    // this.filterData();
    datepicker.close();
  } else {
    this.endDate = null;
    this.startDate = date;
  }
}

  isHovered(date: NgbDate) {
    return this.startDate && !this.endDate && this.hoveredDate && date.after(this.startDate) && date.before(this.hoveredDate);
  }

  isInside(date: NgbDate) {
    return this.endDate && date.after(this.startDate) && date.before(this.endDate);
  }

  isRange(date: NgbDate) {
    return date.equals(this.startDate) || (this.endDate && date.equals(this.endDate)) || this.isInside(date) || this.isHovered(date);
  }

  validateInput(currentValue: NgbDate | null, input: string): NgbDate | null {
    const parsed = this.formatter.parse(input);
    return parsed && this.calendar.isValid(NgbDate.from(parsed)) ? NgbDate.from(parsed) : currentValue;
  }

  resetCalendar(datepicker){
    this.clearFilterData();
  }

  onRangeSelected(value: IDateRange): void {
    this.firstFieldEmittedValue = value;
    this.startDate = this.customProductService.convertDateForCounterOffer(this.firstFieldEmittedValue.start.toDate());
    this.endDate = this.customProductService.convertDateForCounterOffer(this.firstFieldEmittedValue.end.toDate());
    // this.filterData();
  }
  onRangeSelectedSingle(value: IDateRange): void {
    this.firstFieldEmittedValueSingleCal = value;
    this.startDateSingle = this.firstFieldEmittedValueSingleCal.start.toDate();
  }
  omitSpecialChar(event): any {
    const k = event.charCode;
    return this.isValidLetter(k);
  }
  isValidLetter(k): any {
    return ((k >= 48 && k <= 57));
  }
  onReset(event: Event): void {
    if (event !== undefined) {
      this.dateRangePicker.reset(event);
      this.dateRangePicker.toggleCalendarVisibility(false);
      this.dateRangePicker2.reset(event);
      this.dateRangePicker2.toggleCalendarVisibility(false);
    }
    // this.dateRangePicker.toggleCalendarVisibility(false);
    //  this.dateRangePicker2.toggleCalendarVisibility(false);
    this.startDate = null;
    this.endDate = null;
    this.getQuotesDataTabChange(this.activeTab);
  }
  clear(): any {
    this.showCancelledMsg = false;
    this.showAcceptedMsg = false;
    this.showPlacedBidmsg = false;
    this.showRejectedMsg = false;
  }
  searchQuote(searchWord): any {
    this.showCancelledMsg = false;
    this.showAcceptedMsg = false;
    this.showPlacedBidmsg = false;
    this.showRejectedMsg = false;
    this.noData = false;
    this.searchInput = searchWord.toLowerCase();
    this.searchInput = this.searchInput === '' ? null : this.searchInput;
    this.getQuotesDataTabChange(this.activeTab);
  }
  filterData(): any {
    this.showClear=true;
    this.noData = false;
    this.showCancelledMsg = false;
    this.showAcceptedMsg = false;
    this.showPlacedBidmsg = false;
    this.showRejectedMsg = false;
    // if (this.startDate != null) {
      this.getQuotesDataTabChange(this.activeTab,this.selectedLocation,this.selectedCommodity,this.startDate,this.endDate,this.searchText
        ,this.selectedProduct);
    // }
  }
  clearFilterData(): any {
    this.closebar();
    this.showClear = false;
    this.startDate = null;
    this.endDate = null;
    this.searchText = null;
    this.selectedProduct = [];
    this.selectedCommodity=[]
    this.selectedLocation=[]
    this.getQuotesDataTabChange(this.activeTab);
  }
  openDetailsQuote(quote): any {
    this.customProductService.quotesData = quote.quoteCode;
    this.router.navigate([`./${quote.quoteCode}`], { state: quote, relativeTo: this.route });
  }
  changeTab(data, showMsg?): any {
    this.activeTab = data;
    this.quotesData = this.quotesDataMain;
    this.enableLoader = true;
    this.noData = false;
    if (this.activeTab === 'active') {
     this.quotesTab ='active';
      if (!showMsg){
        this.getQuotesDataTabChange(this.quoteTabNameModel.active);
      }

      if (showMsg) {
        this.showPlacedBidmsg = true;
      } else {
        this.showPlacedBidmsg = false;
      }
      this.showCancelledMsg = false;
      this.showAcceptedMsg = false;
      this.showRejectedMsg = false;
      this.startDate = null;
      this.endDate = null;
    }
    else if (this.activeTab === 'completed') {
      this.quotesTab ='completed';

      if (!showMsg){
        this.getQuotesDataTabChange(this.quoteTabNameModel.accepted);
      }
      if (showMsg) {
        this.showAcceptedMsg = true;
      } else {
        this.showAcceptedMsg = false;
      }
      this.showCancelledMsg = false;
      this.showPlacedBidmsg = false;
      this.showRejectedMsg = false;
    }
    else if (this.activeTab === 'archived') {
      this.quotesTab ='archived';
      if (!showMsg){
        this.getQuotesDataTabChange(this.quoteTabNameModel.archived);
      }
      if (showMsg) {
        if (this.customProductService.quoteStatusName === this.quoteStatusModel.rejected){
          this.showRejectedMsg = true;
          this.showCancelledMsg = false;
        }
        if (this.customProductService.quoteStatusName === this.quoteStatusModel.cancelled){
          this.showCancelledMsg = true;
          this.showRejectedMsg = false;
        }
      } else {
        this.showCancelledMsg = false;
        this.showRejectedMsg = false;
      }
      this.showAcceptedMsg = false;
      this.showPlacedBidmsg = false;
    }
  }
  checkPad(d){
    return (d < 10) ? '0' + d.toString() : d.toString();
  }
  noBidsCheck(result){
          let allBids = [];
          allBids = [
            ...result.quotes,
            ...result.openNegotiationQuotes,
            ...result.orders?result.orders:[],
          ];
          if (allBids?.length > 0) {
            this.noBids = false;
          } else {
            this.noBids = true;
          }
  }
  getQuotesData(quoteStatus: string): void {
    this.noData = false;
    this.enableLoader = true;
    if(this.startDate!= undefined && this.endDate!=undefined){
      this.fromDate = this.startDate?.year+'-'+this.checkPad(this.startDate?.month)+'-'+this.checkPad(this.startDate?.day);
      this.toDate = this.endDate?.year+'-'+this.checkPad(this.endDate?.month)+'-'+this.checkPad(this.endDate?.day);
    }else{
      this.fromDate=null;
      this.toDate=null;
    }
    
    this.customProductService.getQuotesListData(quoteStatus, this.fromDate,this.toDate, this.searchText,this.selectedProduct).pipe(tap(_=>console.log(_))).subscribe(result => {
      this.enableLoader = false;
      this.customProductService.setConfirmtxt(result.confirmMessage);
      this.customProductService.setAccepttxt(result.acceptMessage);     
      if (result !== null && result !== undefined) {
        if (result.quotes !== null && result.quotes !== undefined) {
         if (result.acceptedCount !== undefined && result.acceptedCount !== null){
            this.acceptCount = result.acceptedCount;
         }
          //  moment(new Date()).format("YYYY-MM-DD") // TO-DO ccompare date for today's accepted offer count
         this.samequoteData = result.quotes;
         this.noBidsCheck(result);
         const quoteList = result.openNegotiationQuotes.filter(quote => quote.bidChannel == 'STOREFRONT')
         result.openNegotiationQuotes? this.tenderQuotesListData= quoteList :this.tenderQuotesListData=[];
         this.commodityData=result.commodityTypeList
         this.shiplocations=result.shipToLocations
         this.modifyResponsetoCombinedList()
         if(this.tenderQuotesListData){
          for(let data of this.tenderQuotesListData){
         let todayDate = moment(new Date()).format("YYYY-MM-DD HH:mm:ss");
         let invitationToBidSubmissionDeadline=moment(data.invitationToBidSubmissionDeadline).format("YYYY-MM-DD HH:mm:ss");
          data.editCancelBidDisplay=(invitationToBidSubmissionDeadline<todayDate)?false:true;
            if(data.quoteEntries?.length>0){
              for(let entries of data.quoteEntries){
                this.tcPrice=entries?.tcPrice?.value
                this.rcPrice=entries?.rcPrice?.value
                this.relativePrice=entries?.relativePrice?.value
              }
            }
            else{
              this.toastService.show('Quote entries are not available for tenderId: '+data.tenderId);
            }
           
           }
         }

        }
        if (this.customProductService.bidPlaced) {
          this.showPlacedBidmsg = true;
          this.customProductService.bidPlaced = false;
        }
        if (this.customProductService.isRedirectFromQuotesDetails) {
          this.customProductService.isRedirectFromQuotesDetails = false;
          this.checkQuoteStatusResult(this.customProductService.quoteStatusName);
        }
        if (this.customProductService.cancelled) {
          this.showCancelledMsg = true;
          this.customProductService.cancelled = false;
        }
        if (this.samequoteData.length === 0) {
          this.noData = true;
        }
        if(result && result.materialList){
          this.materialList = result?.materialList?.reduce((unique, o) => {
          if(!unique.some(obj => obj.code === o.code)) {
            unique.push(o);
          }
          return unique;
      },[]);
      }else{
        this.materialList = [];
      }

      if(result){
        this.address=result.address;
        if(result.orders!=null && result.orders!=undefined){
          this.orders = result.orders;
          this.noData = false;
          this.orders.forEach((order)=>{
            order.quoteEntries.forEach(entry => {
              if(entry.priceList && entry.priceList.length){
                entry.priceList = entry.priceList.sort((a, b) => {
                  const nameA = a.kopName?.toUpperCase(); // Convert to uppercase for case-insensitive sort
                  const nameB = b.kopName?.toUpperCase(); // Convert to uppercase for case-insensitive sort

                  if (nameA < nameB) {
                    return -1; // nameA comes before nameB
                  }
                  if (nameA > nameB) {
                    return 1; // nameA comes after nameB
                  }
                  return 0; // nameA and nameB are equal
                });
              }
            });
          })
        }
        else if(this.orders.length === 0||this.orders.length === undefined) {
          this.noData= true;
        }

      }
        this.enableLoader = false;
        this.quotesData = this.samequoteData;
        this.customProductService.getNotificationValue(true);
        //uniqueMaterialList
      }
      else{
        this.toastService.show('Error loading this page:'+(this.error));
      }
    },
      err => {
        this.errorMessage = err;
        this.toastService.show("Sorry something went wrong, please try again!")
        this.enableLoader = false;
   });
  }

  modifyResponsetoCombinedList(){
    if(this.tenderQuotesListData){
      for(let tenders of this.tenderQuotesListData){
        if(tenders.quoteEntries?.length>1){
          var tendersListithSetInfo = tenders.quoteEntries.filter(x=>(x.set!='' && x.set!=undefined));
          if(tendersListithSetInfo?.length>0){
            var ObjectWhichContainsSetInfo= this.groupBy(tendersListithSetInfo,'set');
            var groupList=[];
            for(let item in ObjectWhichContainsSetInfo){
              var newName = ''
              var mainObject:any = {};
              var mainAvailable = false;
              var OptionalTendersWIthoutAnyMain = [];
              var childList = []
              tendersListithSetInfo.forEach(element => {
                if(item == element.set){
                  newName = newName+element.productName+' or ';
                  element.newName = newName;
                  if(element.materialOption == 'MAIN'){
                    mainAvailable = true;
                    mainObject = Object.assign(element);
                  }
                  else if(mainAvailable == false){
                    element.newName = undefined;
                    OptionalTendersWIthoutAnyMain.push(element);
                  }
                  
                  mainObject.newName = newName;
                  childList.push(element);
                }
              });
              mainObject.newName = mainObject.newName.substring(0,mainObject.newName.length-4);
              mainObject.childList = childList;
              if(mainAvailable){
                groupList.push(mainObject);
              }
              if(groupList.length>0){
                tenders.groupTenders = groupList;
              }else{
                tenders.groupTenders = [];
              }
              tenders.IndividualTenders = tenders.quoteEntries.filter(x=>(x.set=='' || x.set == undefined));
             
              if(OptionalTendersWIthoutAnyMain?.length>0){
                tenders.IndividualTenders = tenders.IndividualTenders.concat(OptionalTendersWIthoutAnyMain);
              }
            }
            tenders.combinedTenders=[...tenders?.groupTenders,...tenders.IndividualTenders];
          }
          else{
            tenders.IndividualTenders = tenders.quoteEntries
            tenders.combinedTenders=tenders.IndividualTenders
  
          }
        }
        else{
          tenders.IndividualTenders = tenders.quoteEntries
          tenders.combinedTenders=tenders.IndividualTenders
        }
      }
    }
   
    
  }

  getQuotesDataTabChange(quoteStatus: string,location?,commodity?,fromDate?, toDate?,searchText?,materials?): void {
    this.noData = false;
     this.enableLoader = true;          
    if(this.startDate!= undefined && this.endDate!=undefined){
      this.fromDate = this.startDate?.year+'-'+this.checkPad(this.startDate?.month)+'-'+this.checkPad(this.startDate?.day);
      this.toDate = this.endDate?.year+'-'+this.checkPad(this.endDate?.month)+'-'+this.checkPad(this.endDate?.day);
    }else{
      this.fromDate=null;
      this.toDate=null;
    }
    this.customProductService.getQuotesListData(quoteStatus,this.selectedLocation,this.selectedCommodity,this.fromDate,this.toDate, this.searchText,this.selectedProduct).subscribe(result => {
      this.enableLoader = false;          
        if(result && result.materialList){
          this.materialList = result?.materialList?.reduce((unique, o) => {
          if(!unique.some(obj => obj.code === o.code)) {
            unique.push(o);
          }
          return unique;
      },[]);
      }else{
        this.materialList = [];
      }
      
      if (result !== null && result !== undefined) {
        if (result.quotes !== null && result.quotes !== undefined) {
         if (result.acceptedCount !== undefined && result.acceptedCount !== null){
            this.acceptCount = result.acceptedCount;
         }
          //  moment(new Date()).format("YYYY-MM-DD") // TO-DO ccompare date for today's accepted offer count
         this.samequoteData = result.quotes;
         this.noBidsCheck(result);
         const quoteList = result.openNegotiationQuotes.filter(quote => quote.bidChannel == 'STOREFRONT')
         result.openNegotiationQuotes? this.tenderQuotesListData= quoteList: this.tenderQuotesListData=[];
         this.modifyResponsetoCombinedList();
         if(this.tenderQuotesListData){
          for(let data of this.tenderQuotesListData){
         let todayDate = moment(new Date()).format("YYYY-MM-DD HH:mm:ss");
         let invitationToBidSubmissionDeadline=moment(data.invitationToBidSubmissionDeadline).format("YYYY-MM-DD HH:mm:ss");
          data.editCancelBidDisplay=(invitationToBidSubmissionDeadline<todayDate)?false:true;
          }
        }
        }
        this.customProductService.isRedirectFromQuotesDetails = false;
        if (this.samequoteData.length === 0) {
          this.noData = true;
        }else {
          this.noData = false;
        }
        this.enableLoader = false;
        this.quotesData = this.samequoteData;
      }
      if(result){
        this.address=result.address;
        if(result && Array.isArray(result.orders) && result.orders.length>0){
          this.orders = result.orders;
          this.noData = false;
                    this.orders.forEach((order)=>{
            order.quoteEntries.forEach(quote => {
              if(quote.priceList && quote.priceList.length){
                quote.priceList = quote.priceList.sort((a, b) => {
                  const nameA = a.kopName?.toUpperCase(); // Convert to uppercase for case-insensitive sort
                  const nameB = b.kopName?.toUpperCase(); // Convert to uppercase for case-insensitive sort

                  if (nameA < nameB) {
                    return -1; // nameA comes before nameB
                  }
                  if (nameA > nameB) {
                    return 1; // nameA comes after nameB
                  }
                  return 0; // nameA and nameB are equal
                });
              }
            });})

        }
        else 
          this.orders = [];
          this.noData= true;
        
      }
      
      
    },
      err => {
        this.toastService.show(this.error);
        this.enableLoader = false;
      });
  }
  groupBy = (arr, property) => {
    return arr.reduce((acc, cur) => {
      acc[cur[property]] = [...acc[cur[property]] || [], cur];
      return acc;
    }, {});
  }
  convertDate(dateString,timezone): any {
    if (dateString) {
      if(timezone){
        return moment.parseZone(dateString).utcOffset(timezone.timeZoneFormat).format('DD/MM/YYYY HH:mm');
      }
      else{
        return moment(dateString).format('DD/MM/YYYY HH:mm');
      }
    
    }else{
      return '';
    }
  }
  // convertTime(dateString): any {
  //   if (dateString) {
  //     const dateSplit = dateString.split('T');
  //     const timeSplit = dateSplit[1].split('+');
  //     return timeSplit[0];
  //   }
  // }
  convertDateOnly(dateString): any {
    if (dateString) {
      // const momentObj = moment(dateString);
      // return  momentObj.format('YY/MM/DD');
      return moment.utc(dateString).local().format('DD/MM/YYYY');
    }
  }
  convertingDateOnly(dateString): any {
    if (dateString) {
      // const momentObj = moment(dateString);
      // return  momentObj.format('YY/MM/DD');
      return moment.utc(dateString).local().format('DD/MM/YYYY');
    }
  }
  checkQuoteStatusResult(quoteStatus): any {
    if (quoteStatus) {
      if (quoteStatus === this.quoteStatusModel.accepted) {
       // this.showAcceptedMsg = true;
        this.activeTab = 'completed';
        this.changeTab('completed', true);
      } else if (quoteStatus === this.quoteStatusModel.bidExpired || quoteStatus === this.quoteStatusModel.offerExpired ||
        quoteStatus === this.quoteStatusModel.rejected || quoteStatus === this.quoteStatusModel.cancelled) {
        this.changeTab('archived', true);
        if(quoteStatus == this.quoteStatusModel.cancelled){
          this.showCancelledMsg = true;
        }
        this.customProductService.cancelled = false;
        this.activeTab = 'archived';
      } else if (quoteStatus === this.quoteStatusModel.bidPlaced) {
        this.changeTab('active', true);
        this.showPlacedBidmsg = true;
        this.activeTab = 'active';
        this.customProductService.bidPlaced = false;
      }
    }

  }
  // tslint:disable-next-line:typedef
  async openAcceptModal(data?: any) {
    return await this.acceptModalComponent.open(data);
  }
// tslint:disable-next-line:typedef
   openCancelModal(data?: any,fromScreen?:string) {
    
    const modalRef = this.ModalService.open(CancelBidModalComponent, { centered: true , size: 'md'});
    modalRef.componentInstance.data = data;
    modalRef.componentInstance.from = fromScreen;
  }
// tslint:disable-next-line:typedef
async openRejectModal(data?: any) {
  return await this.rejectBidModalComponent.open(data);
}

// tslint:disable-next-line:typedef
  async openCounterOfferModal(content: any, data?: any) {
    this.focus = true;
    data.portName = null;
    if ( data.quoteEntries !== undefined ){
      if (data.quoteEntries[0].portName !== undefined) {
        data.portName = data.quoteEntries[0].portName;
      }
      if (data.quoteEntries[0].product !== undefined){
        if (data.quoteEntries[0].product.maximumQty !== undefined && data.quoteEntries[0].product.minimumQty !== undefined) {
          data.maximumQty = data.quoteEntries[0].product.maximumQty;
          data.minimumQty = data.quoteEntries[0].product.minimumQty;
        }
      }
    }
    return await this.couterOfferModalComponent.open(content, data);
  }

  expiryCalculate(quoteValidity): string{
    if (quoteValidity){
      return this.expiryCalculator(quoteValidity);
     // return this.customProductService.expiryCalculate.call(this,quoteValidity);
    }
  }
  expiryCalculator(validityDate): any {
    let counterTime = '';
    validityDate = moment(validityDate);
    const eventTime1 = validityDate.format(); // Timestamp - Sun, 21 Apr 2013 13:00:00 GMT
    const eventTime: any = moment(eventTime1).format('X');
    const currentTime: any = moment().format('X'); // Timestamp - Sun, 21 Apr 2013 12:30:00 GMT
    const diffTime = eventTime - currentTime;
    let duration: any = moment.duration(diffTime * 1000, 'milliseconds');
    const interval = 1000;
    duration = moment.duration(duration - interval, 'milliseconds');
    const dayRem = duration.days();
    const hRem = duration.hours();
    const mRem = duration.minutes();
    const sRem = duration.seconds();

    
    if(this.lang == 'en'){
      counterTime = this.expiring;
      if (dayRem > 0) {
        counterTime = '';
      }else{
        if (hRem > 0) {
          counterTime += hRem + this.hour;
        }
        if (mRem > 0) {
          counterTime += mRem + this.min;
        }
        if(sRem > 0){
          counterTime += sRem + this.second;

        }
        if (dayRem <= 0 && hRem <= 0 && mRem <= 0 && sRem <= 0) {
          counterTime = '';
        }
      }
    }
    if(this.lang == 'zh'){
      counterTime = '';
      if (dayRem > 0) {
        counterTime = '';
      }else{
        if (hRem > 0) {
          counterTime += hRem + this.hour;
        }
        if (mRem > 0) {
          counterTime += mRem + this.min;
        }
        counterTime += this.expiring
        if (dayRem <= 0 && hRem <= 0 && mRem <= 0) {
          counterTime = '';
        }
      }
    }
    return counterTime;
  }

  toggle(data: any) {
    data.toggle();
    let element3 = document.getElementsByClassName("btn btn-link ngb-dp-arrow-btn");
    for(let i=0;i<element3.length;i++){
      let value = element3[i].getAttribute("title");
      element3[i].setAttribute("title",this.setTitle(value));
    }

   let element4 = document.getElementsByTagName("ngb-datepicker-navigation-select")[0].children;
   for(let i=0;i<element4.length;i++){
      let value = element4[i].getAttribute("title");
      element4[i].setAttribute("title",this.setTitle(value))
   }
  }
  setTitle(value){
    switch(value){
      case "Select year": return this.selectYear;
      case "Select month": return this.selectMonth;
      case "Next month": return this.nextMonth;
      case "Previous month": return this.preMonth;
      default : return;
    }
  }
  // tslint:disable-next-line:use-lifecycle-interface
  ngOnDestroy(): any{
    console.log('destroy called');
}
// tenderLoad(){
//   this.customProductService.getTendersQuoteListData().pipe(tap(_=>console.log(_))).subscribe((data:any) => {
//     //this.tenderDetailsData= data.tenders;
//     this.tenderQuotesListData= data.openNegotiationQuotes;
//     //this.tenderQuote=this.tenderQuotesListData[index].quoteEntries;
// });
// }
openmodal(index:any, screen:any, data?:any){
  if(this.tenderQuotesListData[index].combinedTenders.length <= 1){
    if(this.tenderQuotesListData[index].commodityType!='CN'){
  const ModalRef = this.ModalService.open(TenderPlaceBidComponent,{centered: true,size:'md'});
  ModalRef.componentInstance.screen=screen;
  if(this.tenderQuotesListData[index].combinedTenders[0].childList){
  this.tenderQuotesListData[index].combinedTenders[0].childList.forEach(element=>{
    element.priceshw = element.relativePrice?element.relativePrice.value:'';
    element.indexPriceshw = element.premiumDiscount?element.premiumDiscount.value:'';
  })
}
  ModalRef.componentInstance.tabName=this.tenderQuotesListData[index].combinedTenders[0].pricingOptionsEnum[0].pricingOptions;
  ModalRef.componentInstance.productsInfo=this.tenderQuotesListData[index];
  ModalRef.componentInstance.indexPrice = this.tenderQuotesListData && this.tenderQuotesListData[index].combinedTenders[0].premiumDiscount && this.tenderQuotesListData[index].combinedTenders[0].premiumDiscount.value || '';    
  ModalRef.componentInstance.price = this.tenderQuotesListData && this.tenderQuotesListData[index].combinedTenders[0].relativePrice && this.tenderQuotesListData[index].combinedTenders[0].relativePrice.value || '';
  ModalRef.componentInstance.quantityshw = this.tenderQuotesListData[index].combinedTenders[0].quantity;
  ModalRef.componentInstance.dischargePortshw = this.tenderQuotesListData[index].combinedTenders[0].dischargePortDetails;
  if(this.tenderQuotesListData[index].combinedTenders[0].minimumQuantity && this.tenderQuotesListData[index].combinedTenders[0].maximumQuantity){
    ModalRef.componentInstance.quantity = this.tenderQuotesListData[index].combinedTenders[0].quantity;
    }  

}
    if(this.tenderQuotesListData[index].commodityType=='CN'){
      const ModalRef = this.ModalService.open(TenderPlaceBidComponent,{centered: true,size:'md'});
      ModalRef.componentInstance.screen=screen;
      if(this.tenderQuotesListData[index].combinedTenders[0].childList){
        this.tenderQuotesListData[index].combinedTenders[0].childList.forEach(element=>{
          element.priceshw = element.tcPrice?element.tcPrice.value:'';
          element.indexPriceshw = element.rcPrice?element.rcPrice.value:'';
        })
      }
      ModalRef.componentInstance.productsInfo=this.tenderQuotesListData[index];

      ModalRef.componentInstance.price = this.tenderQuotesListData && this.tenderQuotesListData[index].combinedTenders[0].tcPrice && this.tenderQuotesListData[index].combinedTenders[0].tcPrice?.value || '';    
      ModalRef.componentInstance.indexPrice = this.tenderQuotesListData && this.tenderQuotesListData[index].combinedTenders[0].rcPrice && this.tenderQuotesListData[index].combinedTenders[0].rcPrice?.value || '';  
      ModalRef.componentInstance.quantityshw = this.tenderQuotesListData[index].combinedTenders[0].quantity;
      ModalRef.componentInstance.dischargePortshw = this.tenderQuotesListData[index].combinedTenders[0].dischargePortDetails;
    
    }
  }else if(this.tenderQuotesListData[index].commodityType=='IO' ||
   this.tenderQuotesListData[index].commodityType=='CC' ||this.tenderQuotesListData[index].commodityType=='CA' ){
        const ModalRef = this.ModalService.open(QuoteSelectProductsComponent,{centered: true,size:'md'});
        this.tenderQuotesListData[index].combinedTenders.map(val=>{
          val.checked = true;
          val.quantityshw = val.quantity;
          val.dischargePortshw = val.dischargePortDetails;
          if(val.relativePrice){
            val.relPrice = val.relativePrice?.value;
          }else{
            val.premDiscount = val.premiumDiscount?.value;
          }
          ModalRef.componentInstance.parameter=this.tenderQuotesListData[index].combinedTenders;
          if(this.tenderQuotesListData[index].combinedTenders[0].minimumQuantity && this.tenderQuotesListData[index].combinedTenders[0].maximumQuantity){
            ModalRef.componentInstance.quantity = this.tenderQuotesListData[index].combinedTenders[0].quantity;
            }  
        })
 
        ModalRef.componentInstance.productsInfo = this.tenderQuotesListData[index];
        ModalRef.componentInstance.price =this.tenderQuotesListData && this.tenderQuotesListData[index].combinedTenders[0].relativePrice && this.tenderQuotesListData[index].combinedTenders[0].relativePrice.value || '';
      }
      if(this.tenderQuotesListData[index].commodityType=='CN' && this.tenderQuotesListData[index].combinedTenders.length > 1){
        const ModalRef = this.ModalService.open(ITBQuoteSelectProductsComponent,{centered: true,size:'md'});
        this.tenderQuotesListData[index].combinedTenders.map(val=>{
          val.checked = true;
          val.quantityshw = val.quantity;
          val.dischargePortshw = val.dischargePortDetails;
          ModalRef.componentInstance.parameter=this.tenderQuotesListData[index].combinedTenders;
        })
        ModalRef.componentInstance.productsInfo = this.tenderQuotesListData[index];
        ModalRef.componentInstance.price =this.tenderQuotesListData && this.tenderQuotesListData[index].combinedTenders[0].relativePrice && this.tenderQuotesListData[index].combinedTenders[0].relativePrice.value || '';
        ModalRef.componentInstance.indexPrice =this.tenderQuotesListData && this.tenderQuotesListData[index].combinedTenders[0].relativePrice && this.tenderQuotesListData[index].combinedTenders[0].relativePrice.price || '';
      }
      
}
editOrder(data:any){
if (data.commodityType == 'PO') {
  const ModalRef = this.ModalService.open(ConsignmentsPopupmodalComponent, {
    centered: true,
    size: 'md',
    backdrop: 'static',
    keyboard: false
  });
  console.log(data);
  ModalRef.componentInstance.EditOrders =data;
  ModalRef.componentInstance.popUp = 'Edit Order';
  ModalRef.componentInstance.orders=this.orders
}
}

cancelmodal(index:any){
  const ModalRef = this.ModalService.open(TenderCancelBidComponent,{centered: true,size:'md'});
  ModalRef.componentInstance.productsInfo=this.tenderQuotesListData[index];
 ModalRef.componentInstance.price = this.tenderQuotesListData && this.tenderQuotesListData[0].combinedTenders[0].relativePrice && this.tenderQuotesListData[0].combinedTenders[0].relativePrice.value || '';
 ModalRef.componentInstance.refreshList.subscribe((resp) => {
  this.getQuotesData(this.quoteTabNameModel.active);})
}
acceptbid(index:any){
  const ModalRef = this.ModalService.open(TenderAcceptBidComponent,{centered: true,size:'md'});
  ModalRef.componentInstance.productsInfo=this.tenderQuotesListData[index];
 ModalRef.componentInstance.price = this.tenderQuotesListData && this.tenderQuotesListData[0].combinedTenders[0].relativePrice && this.tenderQuotesListData[0].combinedTenders[0].relativePrice.value || '';
 ModalRef.componentInstance.refreshList.subscribe((resp) => {
  this.getQuotesData(this.quoteTabNameModel.active);})
}
getLabelofConfirmScreen(priceOptions,commodityType,page){
  return this.customProductService.getLabelofConfirmScreen(priceOptions,commodityType,page);

}
getPriceandSymbol(priceOptions,data,commodityType){
  let price = this.getPrice(data);
return this.customProductService.getPriceandSymbol(priceOptions,price,commodityType);
}
getPrice(data){
  if(data?.pricingOptionsEnum[0].pricingOptions == 'INDEX_PRICE' || data?.pricingOptionsEnum[0].pricingOptions == 'LUMP_FIXED_PRICE' || data?.pricingOptionsEnum[0].pricingOptions == 'FIXED_PREMIUM'){
    return data?.premiumDiscount?.value;
  }
  else if( data?.pricingOptionsEnum[0].pricingOptions == 'FIXED_PRICE' ){
    return data?.relativePrice?.value;
  }


}
onCheckboxproductChange(e, id): void {
  this.productlength = 1;
  const checkArray: UntypedFormArray = this.checkedproductform.get(
    'checkArray'
  ) as UntypedFormArray;
  if (e.target.checked) {
    checkArray.push(new UntypedFormControl(e.target.value));
  } else {
    let i = 0;
    checkArray.controls.forEach((item: UntypedFormControl) => {
      if (item.value === e.target.value) {
        checkArray.removeAt(i);
        return;
      }
      i++;
    });
    this.productlength = 0;
  }
  
  this.selectedProduct = checkArray.value;
  // if (checkArray.length > 0) {
  //   this.productlength = 1;
  // }
  // this.materialList.forEach(item => {
  //   if (item.code !== id) {
  //     item.selected = false;
  //   }else{
  //     item.selected = true;
  //   }
  // });
  // if (e.target.checked) {
  //   this.selectedProduct = id;
  // } else {
  //   this.selectedProduct = null;
  //   this.productlength = 0;
  // }
}
onCheckboxlocationChange(e, id): void {
  this.locationlength = 1;
  const checkLocationArray: UntypedFormArray = this.checkedlocationform.get(
    'checkLocationArray'
  ) as UntypedFormArray;
  if (e.target.checked) {
    checkLocationArray.push(new UntypedFormControl(e.target.value));
  } else {
    let i = 0;
    checkLocationArray.controls.forEach((item: UntypedFormControl) => {
      if (item.value === e.target.value) {
        checkLocationArray.removeAt(i);
        return;
      }
      i++;
    });
    this.locationlength = 0;
  }
   this.selectedLocation =  checkLocationArray.value;
  
}
onCheckboxCommodityChange(e, id): void {
  this.commoditylength = 1;
  const checkCommodityArray: UntypedFormArray = this.checkedcommodityform.get(
    'checkCommodityArray'
  ) as UntypedFormArray;
  if (e.target.checked) {
    checkCommodityArray.push(new UntypedFormControl(e.target.value));
  } 
  
  else {
    let i = 0;
    checkCommodityArray.controls.forEach((item: UntypedFormControl) => {
      if (item.value === e.target.value) {
        checkCommodityArray.removeAt(i);
        return;
      }
      i++;
    });
    this.commoditylength = 0;
  }
  console.log('checkCommodityArray', checkCommodityArray.value);
  
  this.selectedCommodity = checkCommodityArray.value;
  
}
getResults(): void {
  this.closebar();
  this.filterData();
}

}

